import React from "react";
import Helmet from "react-helmet";
import Layout from "../components/layout";
import Vimeo from '@u-wave/react-vimeo';
// import Lightbox from 'react-images'

import Gallery from "../components/Gallery";

import full01 from "../assets/images/fulls/famr.jpg";
import full02 from "../assets/images/fulls/famr.us_certifications_wosb.jpg";
import full03 from "../assets/images/fulls/famr.us_certifications.jpg";

import thumb01 from "../assets/images/fulls/famr.jpg";
import thumb02 from "../assets/images/fulls/famr.us_certifications_wosb.jpg";
import thumb03 from "../assets/images/fulls/famr.us_certifications.jpg";



const DEFAULT_IMAGES = [
  {
    id: "1",
    source: full01,
    thumbnail: thumb01,
  },
  {
    id: "2",
    source: full02,
    thumbnail: thumb02,
  },
  {
    id: "3",
    source: full03,
    thumbnail: thumb03,
  },
];

const SportsConnect = () => (
  <Layout>
           <Helmet>
          <title>Andy Miller - FAMR Website and Video Ads</title>
        </Helmet>
        <div id="main">
    <h1>FAMR Website and Video Ads</h1>
    <p>I designed and developed a website for Federal Award Management Registration, also known as the shortened form FAMR. The client was going through a full rebrand and wanted a new, modern site to match. With the whole product being United States government-adjacent, I kept the site clean and light, with U.S. government imagery and accents. With this plan put into action, the new website is clear, concise, and easily recognizable as a site you can associate with the United States government. The website was built with Wordpress, so the client could edit and update the site after I finished my contract.</p>

    <p>I also created help videos for FAMR, keeping the same design principles as the website. These videos were made to be short and to the point to help alleviate customer questions. I edited the videos using Adobe After Effects, animating the walkthrough sections manually to have as much clarity as possible for the customer.</p>

    <a href="https://www.famr.us" class="button marginb">
      Live Website
    </a>
    
    <Vimeo
  video="684073495"
/>

<Vimeo
  video="684073470"
/>
    
    <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                })
              )}
            />
    </div>
  </Layout>
);

export default SportsConnect;
